export default {
    PtCustomFieldLabelPane: {
        fieldMainType: {
            public: 'Company custom fields',
            self: 'Personal custom fields',
            shared: 'Shared Workspace custom fields',
        },
        filter: {
            searchFieldPlaceholder: 'Search for custom fields',
            noFilterData: 'No results',
            noDataToCreate: 'You do not have any custom fields, <a href="{href}" target="_blank" rel="noopener">Create now</a>',
            noData: 'You do not have any custom fields',
        },
        render: {
            noData: {
                DATE: 'Select value',
                NUM: 'Add value',
                LAYER: 'Select value',
                URL: 'Add value',
                OPTION: 'Select value',
                STRING: 'Add value',
            },
        },
        editor: {
            placeholder: {
                DATE: 'Select date',
                NUM: 'Please enter a value',
                LAYER: 'Select existing nodes',
                URL: 'Please enter the URL address',
                OPTION: 'Select existing options',
                STRING: 'Please enter text',
            },
            validator: {
                NUM: {
                    VALID: 'Please enter a valid value.',
                },
            },
            filter: {
                OPTION: {
                    noFilterData: 'No matches found',
                    noData: 'There are no options in this field',
                },
                LAYER: {
                    noFilterData: 'No matches found',
                    noData: 'There are no nodes in this field',
                },
            },
        },
        multiLines: {
            more: 'More',
            less: 'See Less',
        },
        pin: {
            pin: 'Pin in head of list',
            unPin: 'Unpin',
        },
        spaceScopeFieldTip: 'Index value is limited to current workspace',
        spaceScopeEditTip: 'Workspace-specific custom fields are only supported for patent records saved to a Workspace',
        iconCheck: 'Verify AI tagging',
        readAsCheck: 'Modifying the record tag will verify the AI tagging result',
    },
};
